import React from 'react';
import cx from 'classnames';
import Text, { TextSize } from '@move-ui/text';
import { Provider } from '../RadioButtonContext';
import styles from './RadioGroup.module.css';
export const RadioGroup = ({ selectedValue = '', onChange = () => { }, onInvalid = () => { }, isValid, name, disabled, required, errorMessage, errorClassName, children }) => (React.createElement(Provider, { value: {
        selectedValue,
        onChange,
        onInvalid,
        isValid,
        name,
        required,
        disabledGroup: disabled
    } },
    children,
    !disabled && errorMessage && (React.createElement("span", { className: cx(styles.errorMessage, errorClassName) },
        React.createElement(Text, { size: TextSize.XXS, color: "emotion-200" }, errorMessage)))));
//# sourceMappingURL=RadioGroup.js.map